import { render, staticRenderFns } from "./HeaderCustomerInfo.vue?vue&type=template&id=24900b79"
import script from "./HeaderCustomerInfo.vue?vue&type=script&lang=js"
export * from "./HeaderCustomerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports